import { GONE_FISHING_URL, WAITING_PAGE_URL } from 'services/utils/constants/site-urls'
import { isScanAndGoUrl } from 'services/utils/common'

const getRedirectLocation = (response) => {
  const { originalStatusCode: status } = response
  switch (status) {
    case 503:
      const { statusCode, statusMessage } = response
      if (statusCode === 500 && statusMessage === 'UNAVAILABLE') {
        return GONE_FISHING_URL
      }
      return '/back-soon'
    default:
      return '/back-soon'
  }
}
const checkApiUnavailable = (response) => {
  if (response.statusCode === 'UNAVAILABLE') {
    window.location.assign(WAITING_PAGE_URL)
  }
}

export const checkNetworkErrors = (config, response) => {
  const { ignoreError } = config
  const failureCodes = [500, 502, 503, 504, 520, 521, 403, 400]
  checkApiUnavailable(response)
  if (!response.ok) {
    if (response.originalStatusCode === 401) {
      return response
    }
    if (!ignoreError && failureCodes.includes(response.originalStatusCode)) {
      if (!isScanAndGoUrl) {
        const redirectLoc = getRedirectLocation(response)
        window.location.assign(redirectLoc)
        return false
      }
    }
  }
  return response
}
